import React from "react";
import { observer } from "mobx-react";
import { ShowcaseCategoryCreateStore } from "../../store";
import { ShowcaseCategoryCreateForm } from "./ShowcaseCategoryCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ShowcaseCategoryCreateProps = {
  showcaseCategoryCreateStore: ShowcaseCategoryCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ShowcaseCategoryCreate: React.FC<ShowcaseCategoryCreateProps> =
  observer(
    ({ showcaseCategoryCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={showcaseCategoryCreateStore.isSaving} />
          <ShowcaseCategoryCreateForm
            showcaseCategoryCreateStore={showcaseCategoryCreateStore}
            codeError={showcaseCategoryCreateStore.errors.code?.message}
            onCodeChange={(value: string) => {
              showcaseCategoryCreateStore.setCodeValue(value);
            }}
            code={showcaseCategoryCreateStore.entityValues.code}
            nameError={showcaseCategoryCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              showcaseCategoryCreateStore.setNameValue(value);
            }}
            name={showcaseCategoryCreateStore.entityValues.name}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={showcaseCategoryCreateStore.isProcessing}
            onSave={() => showcaseCategoryCreateStore.saveNewShowcaseCategory()}
            onCancel={() =>
              showcaseCategoryCreateStore.cancelNewShowcaseCategory()
            }
          />
          <ErrorDialog
            open={showcaseCategoryCreateStore.errorDialogOpened}
            title={showcaseCategoryCreateStore.errorTitle}
            description={showcaseCategoryCreateStore.errorDescription}
            onClose={() => showcaseCategoryCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
